import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

const medal = (rank) =>
  rank === 1 ? "#C48A31" : rank === 2 ? "#8A8A8A" : rank === 3 ? "#9C6644" : null;

export const Leaderboard = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/leaderboard").then((r) => setRows(r.data.leaderboard)).catch(() => setRows([]));
  }, []);

  if (!rows || rows.length < 2) return null;

  return (
    <section data-testid="leaderboard-section">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="label-eyebrow mb-3">This week</div>
          <h2 className="font-display text-3xl md:text-4xl">Team leaderboard</h2>
        </div>
        <div className="text-xs text-neutral-500 hidden md:block">Ranked by completion · resets weekly momentum</div>
      </div>
      <div className="card-hairline overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left border-b border-neutral-200">
              <th className="label-eyebrow px-6 py-4 font-normal">#</th>
              <th className="label-eyebrow px-6 py-4 font-normal">Trainee</th>
              <th className="label-eyebrow px-6 py-4 font-normal">Complete</th>
              <th className="label-eyebrow px-6 py-4 font-normal">Lessons this week</th>
              <th className="label-eyebrow px-6 py-4 font-normal">Role-play avg</th>
              <th className="label-eyebrow px-6 py-4 font-normal">Best simulator</th>
              <th className="label-eyebrow px-6 py-4 font-normal">Latest Lab score</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr
                key={r.user_id}
                data-testid={`leaderboard-row-${r.rank}`}
                className={`border-b border-neutral-100 last:border-0 ${r.is_you ? "bg-[color:var(--brand-primary)]/5" : ""}`}
              >
                <td className="px-6 py-4 font-mono text-neutral-400">
                  {medal(r.rank) ? <Trophy size={15} strokeWidth={1.5} style={{ color: medal(r.rank) }} /> : r.rank}
                </td>
                <td className="px-6 py-4 font-medium">
                  {r.name}
                  {r.is_you && (
                    <span className="ml-2 text-[10px] font-mono tracking-wide px-1.5 py-0.5 border" style={{ borderColor: "var(--brand-primary)", color: "var(--brand-primary)" }} data-testid="leaderboard-you-badge">
                      YOU
                    </span>
                  )}
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="progress-hairline w-24 hidden sm:block">
                      <div className="fill" style={{ transform: `scaleX(${(r.percent || 0) / 100})` }} />
                    </div>
                    <span className="font-mono">{r.percent}%</span>
                  </div>
                </td>
                <td className="px-6 py-4 font-mono text-neutral-600">{r.weekly_lessons}</td>
                <td className="px-6 py-4 font-mono text-neutral-600">{r.avg_roleplay != null ? `${r.avg_roleplay}/100` : "—"}</td>
                <td className="px-6 py-4 font-mono text-neutral-600" data-testid={`leaderboard-sim-${r.rank}`}>{r.sim_score != null ? `${r.sim_score}/100` : "—"}</td>
                <td className="px-6 py-4 font-mono" style={{ color: r.lab_score != null ? "var(--brand-primary)" : undefined }}>
                  {r.lab_score != null ? `${r.lab_score}/10` : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
